export default __webpack_public_path__ + "assets/shapes-a5ce10aec05542c16e4c1bc536cf7573.svg";